import { createStore, applyMiddleware } from 'redux';
import thunk from 'redux-thunk';
import { Map } from 'immutable';
import reducers from 'reducers';

const initialState = Map();
export const store = createStore(reducers, initialState, applyMiddleware(thunk));
